import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class NumericInput extends Component {
  constructor(props) {
    super(props);
    this.state = { inputValue: props.value };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && !isNaN(this.props.value)) {
      this.setState({ inputValue: this.props.value });
    }
  }

  handleChange(e) {
    const newValue = e.target.value;
    this.setState({ inputValue: newValue });
    this.props.onChange(newValue);
  }

  handleButtonClick() {
    const { inputValue } = this.state;
    this.props.onClick(inputValue);
  }

  // renderTooltipMessage() {
  //   var status = this.props.status,
  //     name = '';

  //   if (status.match(/success|error/)) {
  //     name = `validation-circle-${status}`;
  //   }

  //   return (
  //     <div className="icon-wrap">
  //       <Icon name={name} />
  //     </div>
  //   );
  // }

  render() {
    var { title, description, disabled, disabledAddButton, status, gapTopSize } = this.props;
    const { inputValue } = this.state;
    var tooltipMessage = null;

    // var inputClassNames = classnames('num-field-regular', {
    //   error: status === 'error',
    //   success: status === 'success',
    //   loading: status === 'loading'
    // });

    // if (status !== 'none') {
    //   tooltipMessage = this.renderTooltipMessage();
    // }
    return (
      <div className="num-input-add">
        <div
          className={classnames('field', {
            ['--gap-top-size-' + gapTopSize]: gapTopSize,
            'secondary-option': !title
          })}
        >
          {title && <div className="field-title">{title}</div>}
          <div className="field-description">{description}</div>
          <div className={classnames('input-wrapper', { 'secondary-option': !title })}>
            {/* <div className={inputClassNames}> */}
            {/* {tooltipMessage} */}
            {/* <InputNumber */}
            <input
              className={classnames('add-number-input', { disabled })}
              ref="inputField"
              type="number"
              value={inputValue}
              disabled={disabled}
              min={0}
              step={1}
              onChange={this.handleChange.bind(this)}
            />
            {/* </div> */}
            <button
              disabled={disabledAddButton}
              className="add-button-input"
              onClick={this.handleButtonClick.bind(this)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    );
  }
}

NumericInput.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledAddButton: PropTypes.bool,
  value: PropTypes.number,
  gapTopSize: PropTypes.oneOf(['sm', 'none']),
  status: PropTypes.oneOf(['error', 'success', 'none', 'loading'])
};

NumericInput.defaultProps = {
  value: 0
};

NumericInput.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

NumericInput.displayName = 'NumericInput';

export default NumericInput;
